<template>
	<v-dialog
		:value="value"
		persistent
		width="auto">
		<v-card height="auto">
			<v-card-title class="headline">
				Agregar Producto
			</v-card-title>
			<v-layout row wrap align-center>
				<v-flex xs12 mb-4>
					<v-divider></v-divider>
				</v-flex>
				<v-flex xs2 pl-3>
					<v-subheader class="pl-0">
						Almacenes
					</v-subheader>
					<v-select
						class="filter-select"
						hide-details
						item-text="name"
						item-value="id"
						:items="warehouses"
						v-model="productWarehouse"
					>
					</v-select>
				</v-flex>
				<v-flex xs2 pl-3>
					<v-subheader class="pl-0">
						Categorías
					</v-subheader>
					<v-select
						class="filter-select"
						hide-details
						item-text="name"
						item-value="id"
						:items="categories"
						v-model="productCategory"
					>
					</v-select>
				</v-flex>
				<v-flex xs1 pl-3 text-xs-left pt-5>
					<v-btn
						type="button"
						class="btn-success white--text"
						@click="filterProducts">
						<v-icon>filter_list</v-icon>
					</v-btn>
				</v-flex>
				<v-flex xs12 mt-5>
					<table-run
						:columns="productColumns"
						:rows="productRows"
						:include-delete="false"
						:include-export-to-excel="false"
						:include-options="false"
						:include-switch="false"
						:include-settings="false"
						:include-delete-single="false"
						selectable
						@on-search-event="searchProductsByColumn">
						<template slot="rows" scope="props">
							<td>{{ props.row.code }}</td>
							<td>{{ props.row.warehouseName }}</td>
							<td>{{ props.row.categoryName }}</td>
							<td>{{ props.row.name }}</td>
							<td>{{ props.row.stock }}</td>
							<td class="px-2">
								<v-text-field
									type="number"
									class="input-border-inset width-60"
									v-model.number="props.row.quantity"
									@keyup="positiveValue(props.row, 'quantity')">
								</v-text-field>
							</td>
							<td class="text-xs-center">{{ props.row.price }}</td>
							<td class="px-2 d-flex">
								<v-text-field
									type="number"
									class="input-border-inset basis-30 mr-2"
									v-model.number="props.row.discount"
									@keyup="positiveValue(props.row, 'discount')">
								</v-text-field>
								<span class="basis-70">%</span>
							</td>
						</template>
					</table-run>
				</v-flex>
				<v-flex xs12 text-xs-right>
					<v-pagination
						v-bind:length="totalModalPages"
						v-model="paramsSummary.page"
						:total-visible="pagesVisible"
						v-on:input="loadSummaryProducts(paramsSummary.page)">
					</v-pagination>
				</v-flex>
			</v-layout>
			<v-card-actions>
				<v-layout row wrap my-3
					align-end
					justify-center>
					<v-flex xs2 pr-2>
						<v-btn
							type="button"
							primary
							class="btn-action"
							@click="closeModal">
							Cancelar
						</v-btn>
					</v-flex>
					<v-flex xs2 pl-2>
						<v-btn
							class="btn-action btn-success white--text"
							:disabled="addProductsDisabled"
							@click.native="updateProducts">
							Guardar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import TableRun from 'table-run';
import mixins from '@/shared/mixins';

function created() {
	this.loadData();
	this.loadSummaryProducts();
}

async function loadData() {
	const paramsFlag = {
		flagMain: 1,
	};
	const urlWarehouses = `${process.env.PRODUCTS_URL}/p/warehouses`;
	const urlCategory = `${process.env.PRODUCTS_URL}/p/categories`;
	const paramsWarehouse = {
		flagActive: 1,
	};
	const paramsCategory = {
		permanent: 1,
	};
	const requests = [
		this.$http.get(urlWarehouses, { params: paramsWarehouse }),
		this.$http.get(urlCategory, { params: paramsFlag }),
		this.$http.get(urlCategory, { params: paramsCategory }),
	];
	const [
		{ data: warehouses },
		{ data: categories },
		{ data: categoriesPermanent },
	] = await Promise.all(requests);
	this.warehouses = [...warehouses];
	if (this.warehouses.length === 1) {
		this.setThisWarehouses(this.warehouses[0]);
	}
	this.fillCategories(categories, categoriesPermanent);
}

function setThisWarehouses(warehouse) {
	this.productWarehouse = warehouse.id;
}

function fillCategories(categories, categoriesPermanent) {
	categoriesPermanent.forEach((categoryPermanent) => {
		const newCategory = this.categories.every(c => c.id !== categoryPermanent.id);
		if (newCategory) {
			this.categories.push(categoryPermanent);
		}
	});
	categories.forEach((category) => {
		const newCategory = this.categories.every(c => c.id !== category.id);
		if (newCategory) {
			this.categories.push(category);
		}
	});
}

async function loadSummaryProducts(page = 1) {
	this.paramsSummary.page = page;
	const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/products`, { params: this.paramsSummary });
	this.totalModalPages = Number(response.headers.get('x-last-page'));
	this.productRows = response.data.map((product) => {
		const newProduct = { ...product };
		newProduct.quantity = 1;
		newProduct.isSelected = false;
		newProduct.discount = 0;
		return newProduct;
	});
}

function searchProductsByColumn(search) {
	this.paramsSummary.code = search;
	this.loadSummaryProducts();
}

function positiveValue(product, prop) {
	const productIndex = this.productRows.findIndex(pro => pro.id === product.id);
	if (productIndex > -1) {
		this.productRows[productIndex].isSelected = product[prop] && product[prop] > 0;
	}
}

function pagesVisible() {
	if (this.totalModalPages >= 1 && this.totalModalPages < 5) {
		return this.totalModalPages;
	}
	return 5;
}

function addProductsDisabled() {
	return this.productRows.every(product => !product.isSelected);
}

async function updateProducts() {
	const details = this.productRows.map((product) => {
		const newProduct = { ...product };
		if (product.isSelected) {
			newProduct.detail = {
				brandId: product.brandId,
				categoryId: product.categoryId,
				unitId: product.unitId,
				unitCode: product.unitCode,
				code: product.code,
				createdAt: product.createdAt,
				discount: product.discount,
				flagIgv: product.flagIgv,
				flagIgvRequired: product.flagIgvRequired,
				id: product.id,
				igvId: product.igvId,
				name: product.name,
				price: product.price,
				productType: product.type,
				quantity: Number(product.quantity),
				stockQuantity: product.stock,
				warProductsId: product.id,
				warWarehousesId: product.warehouseId,
				categoryName: product.categoryName,
				priceSoles: product.priceSoles,
			};
		}
		return newProduct.detail;
	});
	const model = details.filter(detail => detail);
	const productWithOutWarehouse = this.productRows.find(p => p.isSelected && !p.warehouseId);
	if (!productWithOutWarehouse) {
		this.$emit('products-to-pay', model);
		this.showNotification('Se agregaron nuevos productos.', 'success');
		this.dialog = false;
		this.closeModal();
	} else if (productWithOutWarehouse) {
		this.showNotification('Uno o más productos seleccionados ya han sido agregados y no cuentan con un almacén asignado.', 'error');
	} else {
		this.showNotification('Uno o más productos seleccionados no cuentan con un almacén asignado.', 'error');
	}
}

function filterProducts() {
	if (this.productCategory > 0) {
		this.paramsSummary.categories = this.productCategory;
	} else {
		delete this.paramsSummary.categories;
	}
	if (this.productWarehouse > 0) {
		this.paramsSummary.warehouses = this.productWarehouse;
	} else {
		delete this.paramsSummary.warehouses;
	}
	this.loadSummaryProducts();
}

function closeModal() {
	this.$emit('close-modal');
}

function data() {
	return {
		categories: [
			{ id: 0, name: 'Todas' },
		],
		categoriesPermantents: [
			{ id: 0, name: 'Todas' },
		],
		totalModalPages: 5,
		paramsSummary: {
			page: 1,
			limit: 10,
			withTransfer: 1,
		},
		productColumns: [
			{ id: 1, name: 'Cod. Prod.', code: 'code' },
			{ id: 2, name: 'Almacén', code: 'warehouse' },
			{ id: 3, name: 'Categoría', code: 'category' },
			{ id: 4, name: 'Nombre Prod.', code: 'name' },
			{ id: 5, name: 'Stock', code: 'stock' },
			{ id: 6, name: 'Cant.', code: 'quantity' },
			{ id: 7, name: 'Precio', code: 'price' },
			{ id: 8, name: 'Descuento %', code: 'discount' },
		],
		productCategory: 0,
		productRows: [],
		productWarehouse: 0,
		warehouses: [],
	};
}

export default {
	name: 'payment-dialog',
	components: {
		TableRun,
	},
	computed: {
		addProductsDisabled,
		pagesVisible,
	},
	created,
	data,
	methods: {
		closeModal,
		fillCategories,
		filterProducts,
		loadData,
		loadSummaryProducts,
		positiveValue,
		searchProductsByColumn,
		setThisWarehouses,
		updateProducts,
	},
	mixins,
	props: {
		value: null,
	},
};
</script>




// WEBPACK FOOTER //
// payment-dialog.vue?99e8f2e6